import React from "react";
import { Divider, Paper } from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import TypographyVariants from "./TypographyVariants";
import TypographyProperties from "./TypographyProperties";

const TypographyPage = () => {
  return (
    <Paper elevation={0}>
      <PageTitleBox
        title={"Typography"}
        description={
          "Use typography to present your design and content as clearly and efficiently as possible."
        }
      />
      <Divider light />
      <TypographyVariants />
      <TypographyProperties />
    </Paper>
  );
};

export default TypographyPage;
